// Viewer routes. Watching never requires login; the LoginModal opens only on comment/account.
import { Navigate, Route, Routes } from "react-router-dom";
import { Navbar } from "./components/Navbar.js";
import { LoginModal } from "./components/LoginModal.js";
import { useSetupStatus } from "./api/hooks.js";
import { HomePage } from "./pages/HomePage.js";
import { StreamPage } from "./pages/StreamPage.js";
import { StudioPage } from "./pages/StudioPage.js";
import { StudioStreamPage } from "./pages/StudioStreamPage.js";
import { ProfilePage } from "./pages/ProfilePage.js";
import { NotConfiguredPage } from "./pages/NotConfiguredPage.js";

export function App() {
  const setup = useSetupStatus();

  // First run: not yet configured -> point to the admin setup wizard.
  if (setup.data && setup.data.initialized === false) {
    return <NotConfiguredPage />;
  }

  return (
    <div className="min-h-full text-foreground">
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/watch/:id" element={<StreamPage />} />
        <Route path="/s/:id" element={<StreamPage />} />
        <Route path="/studio" element={<StudioPage />} />
        <Route path="/studio/:uuid" element={<StudioStreamPage />} />
        <Route path="/me" element={<ProfilePage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <LoginModal />
    </div>
  );
}
